import { useEffect } from "react";
import { Alert, Card, Spinner } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";
import { ActiveQueueProvider, ActiveQueueTable } from "pages/dashboard/queue/tabs/active";
import { useApp } from "common/context";
import { FormattedMessage } from "react-intl";

export const ActiveQueue = props => {

    const { api } = useApp();

    const [state, setState] = useSuperState({
        loading: true,
        error: null,
        entries: [],
        appstream_fleet_name: null
    });

    const { loading, error, entries, appstream_fleet_name } = state;

    const clearError = () => setState({ error: null });

    const fetchActiveQueue = async () => {

        try {

            setState({ loading: true });

            const { entries } = await api.get(`/api/appstream/queue/list`, { appstream_fleet_name });
            setState({
                entries,
                loading: false
            });

        } catch (e){

            const error = e?.err || e?.message || e;
            setState({
                loading: false,
                error
            });

        }

    };

    useEffect(() => {

        let interval;

        (async () => {

            await fetchActiveQueue();

            setState({ loading: false });

            interval = setInterval(fetchActiveQueue, 10000);

        })();

        return () => {

            clearInterval(interval);

        };

    }, [appstream_fleet_name]);

    const context = {
        entries,
        appstream_fleet_name,
        loading
    };

    return (
        <ActiveQueueProvider value={context}>
            <div className="active-queue">

                <Alert variant="danger" dismissible show={!!error} onClose={clearError}>
                    {error}
                </Alert>

                <Card>
                    <Card.Body>
                        {loading ?
                            (
                                <div className="text-center">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">
                                            <FormattedMessage
                                                defaultMessage="Loading..."
                                                id="label.loading"
                                                />
                                        </span>
                                    </Spinner>
                                </div>
                            )
                            :
                            (
                                <ActiveQueueTable/>
                            )
                        }

                    </Card.Body>
                </Card>
            </div>
        </ActiveQueueProvider>
    );
};